module.exports = __webpack_public_path__ + "assets/img/poster-mobile.37d4e119.jpg";